// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-dcae2026] .el-form-item__label {\n  overflow: hidden;\n  white-space: pre-wrap;\n  line-height: 40px !important;\n}\n.radio-control[data-v-dcae2026] {\n  font-family: Arial, sans-serif;\n}\n.add-option-row[data-v-dcae2026] {\n  margin-top: 16px;\n}", ""]);
// Exports
module.exports = exports;
